import { Fragment } from 'react';
import type { OutreachLeadRow } from '../../../shared/types';
import { formatDate } from '../../components/primitives';
import { scoreBreakdown } from './helpers';

export function ScoreBreakdown({ lead }: { lead: OutreachLeadRow }) {
  const components = scoreBreakdown(lead);
  if (components) {
    return (
      <>
        {components.map((component) => (
          <Fragment key={component.key}>
            <div className="outreach-sb">
              <span className="outreach-sb-label">{component.label}</span>
              <span className="outreach-sb-bar">
                <i style={{
                  width: `${Math.max(0, Math.min(100, (component.points / component.maximum) * 100))}%`,
                }} />
              </span>
              <span className="outreach-sb-num">{component.points} / {component.maximum}</span>
            </div>
            <div className="outreach-sb-why">{component.why}</div>
          </Fragment>
        ))}
      </>
    );
  }

  return (
    <>
      <div className="outreach-sb">
        <span className="outreach-sb-label">total</span>
        <span className="outreach-sb-bar">
          <i style={{ width: `${Math.max(0, Math.min(100, lead.score))}%` }} />
        </span>
        <span className="outreach-sb-num">{lead.score} / 100</span>
      </div>
      <div className="outreach-sb-why">
        {lead.band ? `${lead.band}. ` : ''}
        Scored on the {formatDate(lead.run_date)} run. The component scores behind this
        number, business fit, opportunity and reachability, stay in that week's lead book.
      </div>
    </>
  );
}
